import { render, staticRenderFns } from "./InventoryFileLoader.vue?vue&type=template&id=da1ab5b2&"
import script from "./InventoryFileLoader.vue?vue&type=script&lang=js&"
export * from "./InventoryFileLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports